import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-primary text-gray-50 py-8 px-4 mt-12 shadow-inner">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
        {/* Left side: Business name or logo */}
        <div className="flex items-center space-x-3">
          <Link to='/' className="flex items-center space-x-2">
          <img
            src="/logo3.png"
            alt="Jake's RV Logo"
            className="h-12 w-12 rounded-full shadow-md"
          />
          <span className="text-lg font-semibold">Jake’s RV Repair</span>
          </Link>        
        </div>

        {/* Middle: Links */}
        <div className="space-x-4 text-sm">
          <a href="/gallery" className="hover:text-black transition">Gallery</a>
          <a href="/about" className="hover:text-black transition">About Us</a>
          <a href="/contact" className="hover:text-black transition">Contact</a>
        </div>

        {/* Right: Social icon */}
        <div>
          <a
            href="https://www.facebook.com/people/Jakes-RV-Repair-and-Maintenance/61570466512452/#"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center hover:text-black transition"
          >
            <i className="fab fa-facebook fa-lg mr-2"></i>
            <span className="text-sm">Follow us on Facebook</span>
          </a>
        </div>
      </div>

      <div className="text-center text-xs text-black mt-6">
        &copy; {new Date().getFullYear()} Jake’s RV Repair & Maintenance. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
